import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { camelize } from '../../util/string';
import { propTypes } from '../../util/types';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import moment from 'moment';

import FallbackPage from './FallbackPage';
import { ASSET_NAME } from './LandingPage.duck';
import { getMetadata } from '../PageBuilder/PageBuilder';

import { getListingsById } from '../../ducks/marketplaceData.duck';
import { Page, NamedLink, ListingCardBox, InlineTextButton, AvatarSmall } from '../../components';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

import { useConfiguration } from '../../context/configurationContext';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { useHistory, Link } from 'react-router-dom';

import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import SearchBarForm from './SearchBarForm';
// import CardBox from './CardBox';
import TrendingCardSwiper from './TrendingCardSwiper';
import hostImage from '../../assets/images/hostImg.png';
import jobImage from '../../assets/images/businessman.png';
import homeImage from '../../assets/images/home.png';
import roomsImage from '../../assets/images/rooms.png';
import villasImage from '../../assets/images/villas.png';
import cabinsImage from '../../assets/images/cabins.png';
import carImage from '../../assets/images/car.png';
import farmhouseImage from '../../assets/images/farmhouse.png';
import beachImage from '../../assets/images/beachFront.png';
import appartmentsImage from '../../assets/images/appartments.png';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';

import css from './LandingPageNew.module.css';

const initialValues = {
  location: null,
  checkIn: "",
  checkOut: "",
  guests: 0,
}

export const LandingPageComponent = props => {
  const config = useConfiguration();
  const history = useHistory();
  const marketplaceName = config.marketplaceName;

  const {
    pageAssetsData,
    inProgress,
    error,
    listings,
    intl,
    scrollingDisabled,
    onUpdateFavorites,
    reviews,
    currentUser
  } = props;

  const { meta = {} } = pageAssetsData?.[camelize(ASSET_NAME)]?.data || {};
  const pageMetaProps = getMetadata(meta, 'Article');

// ==================================================================
// LANDINGPAGE.JS - CORRECT handleSubmit (Original Safe Version)
// ==================================================================
// This version only processes locations that were SELECTED from dropdown
// This prevents showing all listings when manually typed text has no bounds
// ==================================================================

const handleSubmit = values => {
  const { location, bookingDates, guests } = values;
  let path = '/s?';
  
  // Only process location if it has proper data from dropdown selection
  if (location?.search && location?.selectedPlace?.address) {
    const { bounds, address } = location.selectedPlace;
    
    // If bounds exist, use them for precise location filtering
    if (bounds) {
      path += `address=${encodeURIComponent(address)}&bounds=${encodeURIComponent(
        `${bounds.ne.lat},${bounds.ne.lng},${bounds.sw.lat},${bounds.sw.lng}`
      )}`;
    } else {
      // Fallback: just use address if no bounds (shouldn't happen with proper selection)
      path += `address=${encodeURIComponent(address)}`;
    }
  }

  if (bookingDates) {
    const { startDate, endDate } = bookingDates;
    const fromDate = moment(startDate).format('YYYY-MM-DD');
    const toDate = moment(endDate).format('YYYY-MM-DD');
    path += `${path.length > 3 ? '&' : ''}dates=${encodeURIComponent(`${fromDate},${toDate}`)}`;
  }

  if (guests) {
    path += `${path.length > 3 ? '&' : ''}pub_guest=${guests}`;
  }

  history.push(path, { searchData: {
    location,
    bookingDates,
    guests
  } });
};

// ==================================================================
// WHY THIS VERSION:
// ==================================================================
//
// Problem: When user types "Lahore" without selecting from dropdown:
// - No bounds data available
// - Search goes to /s? with no location filter
// - Shows ALL listings instead of Lahore listings
//
// Solution: Require user to SELECT from dropdown:
// - Validation in SearchBarForm prevents submission without selection
// - handleSubmit only processes properly selected locations with bounds
// - This ensures accurate location-based filtering
//
// User Experience:
// 1. User types "Lahore"
// 2. Dropdown shows "Lahore, Pakistan" and other suggestions
// 3. User MUST click one of the suggestions
// 4. Then search works with proper location bounds
// 5. Results show only listings in selected location
//
// ==================================================================
// WHY THIS VERSION:
// ==================================================================
//
// Problem: When user types "Lahore" without selecting from dropdown:
// - No bounds data available
// - Search goes to /s? with no location filter
// - Shows ALL listings instead of Lahore listings
//
// Solution: Require user to SELECT from dropdown:
// - Validation in SearchBarForm prevents submission without selection
// - handleSubmit only processes properly selected locations with bounds
// - This ensures accurate location-based filtering
//
// User Experience:
// 1. User types "Lahore"
// 2. Dropdown shows "Lahore, Pakistan" and other suggestions
// 3. User MUST click one of the suggestions
// 4. Then search works with proper location bounds
// 5. Results show only listings in selected location
//
// ==================================================================
  const handleCategoryChange = (e, category) => {
    let path = '/s?';
    
    if (category) {
      path += `${path.length > 3 ? '&' : ''}pub_categoryLevel1=${category}`;
    }

      history.push(path); 
  }

  const TimePartOfLlivio = ({ createdAt }) => {
    const joined = moment(createdAt);
    const now = moment();

    const years = now.diff(joined, 'years');
    joined.add(years, 'years');

    const months = now.diff(joined, 'months');
    joined.add(months, 'months');

    const days = now.diff(joined, 'days');

    let display = '';

    if (years > 0) {
      display = `${years} ${years === 1 ? 'Year' : 'Years'}`;
    } else if (months > 0) {
      display = `${months} ${months === 1 ? 'Month' : 'Months'}`;
    } else {
      // Includes the case where all are 0, meaning today
      display = `${days === 0 ? 1 : days} ${days === 1 ? 'Day' : 'Days'}`;
    }

    return <span>{display} part of Llivo</span>;
  };

   const handleToggleFavorites = (parameters) => {
    const { currentUser, history } = parameters;

    if (!currentUser) {
      history.push('/login');
    } else {
      const { id, onUpdateFavorites } = parameters;
      const isFavorite = currentUser?.attributes.profile.privateData.favorites?.includes(id?.uuid)
      const {
        attributes: { profile },
      } = currentUser;
      const { favorites = [] } = profile.privateData || {};

      let payload;

      if (!profile.privateData || !profile.privateData?.favorites) {
        payload = {
          privateData: {
            favorites: [id?.uuid],
          },
        };
      } else if (isFavorite) {
        payload = {
          privateData: {
            favorites: favorites.filter(f => f !== id?.uuid),
          },
        };
      } else {
        payload = {
          privateData: {
            favorites: [...favorites, id?.uuid],
          },
        };
      }
      onUpdateFavorites(payload);
    }
  };

  const toggleFavorites = (id) => {
    handleToggleFavorites({
      currentUser,
      onUpdateFavorites,
      history,
      id,
    });
  }

  return (
    <Page {...pageMetaProps}>
      <div className={css.landingPageNew}>
        <TopbarContainer />

        <section className={css.heroSection}>
          <div className={css.bannerContent}>
            <div className={css.bannerHeading}>Your stay starts the moment you arrive—hosts provide both accommodation and transportation pickup</div>
          </div>
          <div className={css.heroBanner}>
            <SearchBarForm intl={intl} handleSubmit={handleSubmit} initialValues={initialValues} />
          </div>
        </section>

        <section className={css.button}>
          <div className={css.buttonContent}>
            <Link
              to="/p/llivo-benefits"
              className={css.applyHostBtn}
            >
              <FormattedMessage id="LandingPage.hostbutton" />
            </Link>
          </div>
        </section>

        <section className={css.mainContainer}>
          <div className={css.filterSection}>
            <div className={css.filterRow}>

              {/*<ul className={css.filterList}>
                <li>
                  <InlineTextButton className={css.filterListBtn} onClick={((e)=> handleCategoryChange(e, "homes") )}>
                    <img src={homeImage} alt="icon" />
                    <span><FormattedMessage id="LandingPage.filterList.Home" /></span>
                  </InlineTextButton>
                </li>
                <li>
                  <InlineTextButton className={css.filterListBtn} onClick={((e)=> handleCategoryChange(e, "rooms") )}>
                    <img src={roomsImage} alt="icon" />
                    <span><FormattedMessage id="LandingPage.filterList.Rooms" /></span>
                  </InlineTextButton>
                </li>
                <li>
                  <InlineTextButton className={css.filterListBtn} onClick={((e)=> handleCategoryChange(e, "villas") )}>
                    <img src={villasImage} alt="icon" />
                    <span><FormattedMessage id="LandingPage.filterList.Villas" /></span>
                  </InlineTextButton>
                </li>
                <li>
                  <InlineTextButton className={css.filterListBtn} onClick={((e)=> handleCategoryChange(e, "apartment") )}>
                    <img src={appartmentsImage} alt="icon" />
                    <span><FormattedMessage id="LandingPage.filterList.Apartaments" /></span>
                  </InlineTextButton>
                </li>
                <li>
                  <InlineTextButton className={css.filterListBtn} onClick={((e)=> handleCategoryChange(e, "farm-house") )}>
                    <img src={farmhouseImage} alt="icon" />
                    <span><FormattedMessage id="LandingPage.filterList.FarmHouse" /></span>
                  </InlineTextButton>
                </li>
                <li>
                  <InlineTextButton className={css.filterListBtn} onClick={((e)=> handleCategoryChange(e, "beachfront") )}>
                    <img src={beachImage} alt="icon" />
                    <span><FormattedMessage id="LandingPage.filterList.BeachFront" /></span>
                  </InlineTextButton>
                </li>
                <li>
                  <InlineTextButton className={css.filterListBtn} onClick={((e)=> handleCategoryChange(e, "cabins") )}>
                    <img src={cabinsImage} alt="icon" />
                    <span><FormattedMessage id="LandingPage.filterList.Cabins" /></span>
                  </InlineTextButton>
                </li>
                <li>
                  <InlineTextButton className={css.filterListBtn} onClick={((e)=> handleCategoryChange(e, "apartment") )}>
                    <img src={appartmentsImage} alt="icon" />
                    <span><FormattedMessage id="LandingPage.filterList.Apartaments" /></span>
                  </InlineTextButton>
                </li>
                <li>
                  <InlineTextButton className={css.filterListBtn} onClick={((e)=> handleCategoryChange(e, "transport") )}>
                    <img src={carImage} alt="icon" />
                    <span><FormattedMessage id="LandingPage.filterList.GuestTransport" /></span>
                  </InlineTextButton>
                </li>
              </ul>*/}

              {/*<button className={css.filterBtn}>
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 22 18" fill="none">
                  <path d="M22 15H1M22 3H1M22 9.4H1" stroke="black" stroke-width="1.5"/>
                  <circle cx="17.5" cy="2.5" r="2" fill="white" stroke="black"/>
                  <circle cx="2.5" cy="15.5" r="2" fill="white" stroke="black"/>
                  <circle cx="11.5" cy="9.5" r="2" fill="white" stroke="black"/>
                </svg>
                <span><FormattedMessage id="LandingPage.filterList.Filter" /></span>
              </button>*/}
            </div>
          </div>
          <div className={css.featuredCardSection}>
            <div className={css.cardSection}>
              { listings
              .filter(listing => listing?.attributes?.publicData?.guests_favorite)
              .map((listing)=>(
                  <ListingCardBox listing={listing} intl={intl} reviews={reviews} toggleFavorites={toggleFavorites} />
                ))
              }
            </div>
          </div>
        </section>

        {/*<s ection className={css.trendingDestinationSection}>
          <div className={css.mainContainer}>
            <div className={css.trendingHeading}><FormattedMessage id="LandingPage.trendingHeading" /></div>
          </div>
          <div className={css.trendingCardWrapper}>
            <TrendingCardSwiper />
          </div>
        </section>
        */}

        <div className={css.mainContainer}>
          {/*<section className={css.intrestedSection}>
            <div className={css.intrestedHeading}><FormattedMessage id="LandingPage.intrestedHeading" /></div>
            <div className={css.intrestedCardSection}>
              <div className={css.cardSection}>
                { listings
                  .filter(listing => listing?.attributes?.publicData?.featuredListing)
                  .map((listing)=>(
                    <ListingCardBox listing={listing} intl={intl} reviews={reviews} toggleFavorites={toggleFavorites} />
                  ))
                }
              </div>
            </div>
          </section>

          <section className={css.becomeHostSection}>
            <div className={css.hostRow}>
              <div className={css.hostBox}>
                <div className={css.hostHeading}><FormattedMessage id="LandingPage.hostHeading" /></div>
                <div className={css.hostSubText}><FormattedMessage id="LandingPage.hostSubText" /></div>
                <img src={hostImage} alt="host img" className={css.mobileHostImg} />
                <div>
                  <ul className={css.bullets} >
                    <li>
                      Keep More of What You Earn – Lower fees mean more money in your pocket.
                    </li>
                    <li>
                      Connect Directly With Guests – Offer personal touches and build lasting connections.
                    </li>
                    <li>
                      Earn Even Without a Property – Provide optional airport pickups and transport services.
                    </li>
                    <li>
                      Secure, Reliable, and Easy to Use – Verified users, secure payments, and full control.
                    </li>
                  </ul>
                </div>

                <NamedLink name="NewListingPage" className={css.joinHostBtn}><FormattedMessage id="LandingPage.joinHostBtn" /></NamedLink>
              </div>
              <img src={hostImage} alt="host img" className={css.desktopHostImg} />
            </div>
          </section>*/}
        </div>

        <section 
          className={css.jobSection}
          style={{
            backgroundImage: `url(${jobImage})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className={css.jobBox}>
            {/*<div className={css.featureHeading}><FormattedMessage id="LandingPage.featureHeading" /></div>
            <div className={css.lookingHeading}><FormattedMessage id="LandingPage.lookingHeading" /></div>
            <div className={css.aboutJob}><FormattedMessage id="LandingPage.aboutJob" /></div>*/}
            <h2 className={css.hostHeading}><FormattedMessage id="LandingPage.hostHeading" /></h2>
                  <ul className={css.bulletList}>
                    <li>
                      Keep More of What You Earn – Lower fees mean more money in your pocket.
                    </li>
                    <li>
                      Connect Directly With Guests – Offer personal touches and build lasting connections.
                    </li>
                    <li>
                      Secure, Reliable, and Easy to Use – Verified users, secure payments, and full control.
                    </li>
                  </ul>      
            {/*<NamedLink name="SignupPage" className={css.applyJobBtn}><FormattedMessage id="LandingPage.applyJobBtn" /></NamedLink>*/}
            <NamedLink name="NewListingPage" className={css.applyJobBtn}><FormattedMessage id="LandingPage.joinHostBtn" /></NamedLink>
          </div>
        </section>

         <section>
          <h1 className={css.Heading}> Luxury Vacation Rentals In USA & Airport Pickups</h1>
           <div className={css.content}>
            <p>
              At Llivo, we make your journey as comfortable as your stay. Discover the best <b>Luxury Vacation Rentals in USA</b> — from modern city apartments in New York and Los Angeles to private beachfront villas in California and family-friendly homes in Las Vegas, Miami, and San Francisco.
              Enjoy <a href="https://www.llivo.com/p/luxury-vacation-rental-in-usa"  rel="noopener noreferrer"><b>Premium Stays with Pickup & Drop-Off</b></a>, trusted local hosts, secure bookings, and transparent pricing with no hidden fees. Every stay is tailored for comfort, reliability, and peace of mind.
             </p>
            <p>
              List your rentals across the USA and anywhere in the world with reliable hosting services to earn extra and have human experience. Join hosts offering thriving <b>vacation rentals in London</b>, Paris, Barcelona and holiday rentals in Las Vegas, Los Angeles, San Francisco, and Dallas with Llivo.
              List your rental or service with Llivo and turn every stay into opportunity.
            </p>
         </div>

         </section>

        {reviews?.length > 0 &&
          <div className={css.mainContainer}>
            <section className={css.abousUsSection}>
              <div className={css.aboutUsHeading}><FormattedMessage id="LandingPage.aboutUsHeading" /></div>
              <div className={css.aboutUsText}><FormattedMessage id="LandingPage.aboutUsText" /></div>

              <div className={css.reviewRow}>
                {reviews?.slice(0, 6).map((review)=>(
                  <div className={css.reviewBox}>
                    <div className={css.userBox}>
                      <AvatarSmall user={ review?.author} className={css.userImage} />
                      <div className={css.userDetails}>
                        <div className={css.userName}>{review?.author?.attributes?.profile?.displayName}</div>
                        <div className={css.reviewTime}><TimePartOfLlivio createdAt={review?.author?.attributes?.createdAt} /></div>
                      </div>
                    </div>
                    <div className={css.reviewText}>{review?.attributes?.content}</div>
                  </div>
                ))}

              </div>
            </section>
          </div>
        }

        {/* ===== Benefits Section ===== */}
        <section className={css.benefitsSection}>
          <div className={css.mainContainer}>
            <h2 className={css.benefitsHeading}>
              Why Choose Llivo Luxury Vacation Rentals USA?
            </h2>
            <div className={css.benefitsGrid}>
              <div className={css.benefitCard}>
                <span className={css.icon}>🏡</span>
                <h3>Verified Luxury Homes</h3>
                <p>
                  Stay in handpicked, premium properties across the USA. Every rental is verified for
                  comfort, quality, and style.
                </p>
              </div>

              <div className={css.benefitCard}>
                <span className={css.icon}>🚖</span>
                <h3>Seamless Pick & Drop</h3>
                <p>
                  Enjoy hassle-free airport transfers. Your vacation starts the moment you land, stress-free.
                </p>
              </div>

              <div className={css.benefitCard}>
                <span className={css.icon}>🔒</span>
                <h3>Safe & Secure Bookings</h3>
                <p>
                  Book with confidence: secure payments, transparent pricing, and trusted hosts every time.
                </p>
              </div>
            </div>
          </div>
        </section>


        <FooterContainer />
      </div>
    </Page>
  );
};

LandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { currentPageResultIds, fetchListingsInProgress, reviews } = state.LandingPage;
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  const listings = getListingsById(state, currentPageResultIds);
  const { currentUser } = state.user

  return {
    listings,
    fetchListingsInProgress,
    pageAssetsData,
    inProgress,
    error,
    scrollingDisabled: isScrollingDisabled(state),
    reviews,
    currentUser,
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateFavorites: (payload) => dispatch(updateProfile(payload)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(LandingPageComponent);

export default LandingPage;